const ALLOWED_SHORTCODES: any = {
  'toc.figures': 1,
  'toc.chapters': 1,
  'toc.tables': 1,
};

export default (html: string) => {
  if (!html) {
    return html;
  }

  const re = /<span.*?data-code="(.*?)">.*?<\/span>/g;

  const code = re.exec(html);

  if (!code) {
    return html;
  }

  const shortcode = code[1];

  if (!ALLOWED_SHORTCODES[shortcode]) {
    return html;
  }

  const replaceValue = `<p>@${shortcode}</p>`;

  return html.replace(re, replaceValue);
};
